import { useFormContext } from "react-hook-form";
import { ErrorMessages } from "../../../../components/errorMessages/errorMessages";

export const InputText = ({ label, name, required = true }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-field mt-4">
      <label htmlFor={name}>{label}</label>
      <input
        {...register(name, {
          required: {
            value: required,
            message: `${label} is required`,
          },
        })}
        placeholder={label}
      />
      <ErrorMessages errors={errors?.[name]?.message} />
    </div>
  );
};
